import { render, staticRenderFns } from "./FileManagerBasic.vue?vue&type=template&id=168bddb4&scoped=true&"
import script from "./FileManagerBasic.vue?vue&type=script&lang=ts&"
export * from "./FileManagerBasic.vue?vue&type=script&lang=ts&"
import style0 from "./FileManagerBasic.vue?vue&type=style&index=0&id=168bddb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168bddb4",
  null
  
)

export default component.exports